const ddadosDadosCadastrais = {
  Titulo: 'Dados da Empresa / Autônomo',
  Campos: {
    //Dados da Empresa (Dados Cadastrais)
    NomeEmpresa: {
      Tipo: 'text',
      Label: 'Nome',
      Tamanho: 255,
      Obrigatorio: true,
    },
    NomeFantasia: {
      Tipo: 'text',
      Label: 'Nome Fantasia',
      Tamanho: 255,
    },
    EmailEmpresa: {
      Tipo: 'text',
      TipoInput: 'email',
      Label: 'E-mail Empresa',
      Tamanho: 80,
      Obrigatorio: true,
    },
    Telefone: {
      Tipo: 'mask',
      Mascara: 'DYNAMIC',
      Label: 'Telefone',
      Obrigatorio: true,
    },
    Celular: {
      Tipo: 'mask',
      Mascara: 'DYNAMIC',
      Label: 'Celular',
      Obrigatorio: true,
    },
    RgIe: {
      Tipo: 'text',
      Label: 'RG/IE',
      Mask: 'RG',
      Tamanho: 50,
      Obrigatorio: true,
    },
    DataNascimentoEmpresa: {
      Tipo: 'date',
      Label: 'Data de Nascimento',
    },
    DataAberturaEmpresa: {
      Tipo: 'date',
      Label: 'Data de Abertura',
      Obrigatorio: true,
    },
    DataOcorrencia: {
      Tipo: 'date',
      Label: 'Data Ocorrência',
      Tooltip:
        'Informe a data de registro da criação da empresa ou da última alteração na junta comercial, ou a data da ata em caso de estatuto. Pessoas Físicas, podem utilizar sempre a data atual.',
      Obrigatorio: true,
    },
    Contador: {
      Tipo: 'suggestion',
      Titulo: 'Contador',
      Label: 'Contador',
      Tooltip: 'CPF/CNPJ - Nome',
      Placeholder: 'CPF/CNPJ - Nome',
      Obrigatorio: false,
    },
    EmailContador: {
      Tipo: 'text',
      TipoInput: 'email',
      Label: 'E-mail Contador',
      Tamanho: 80,
      Obrigatorio: false,
    },
    RegimeTributacao: {
      Tipo: 'combobox',
      Label: 'Regime de Tributação',
      itens: [],
      Obrigatorio: true,
    },
    RegimeTributacaoSolicitacaoDescricao: {
      Tipo: 'text',
      Label: 'Regime de Tributação',
      Tamanho: 255,
    },
    IdGrupo: {
      Tipo: 'combobox',
      Label: 'Grupo',
      Tooltip: 'Grupo',
      Placeholder: 'Grupo',
      Obrigatorio: false,
      itens: [],
    },
    DescricaoAtividade: {
      Tipo: 'textarea',
      Label: 'Descrição da Atividade',
      Tooltip:
        'Informe o objeto social da empresa, dados específicos do seu estatuto ou, em caso de profissionais autônomos, descreva quais atividades deseja realizar',
      Tamanho: 8000,
      Linhas: 5,
      Obrigatorio: true,
    },
  },
};

export { ddadosDadosCadastrais };
